import { useLocation } from "react-router-dom";

import "./PublicAppContainer.scss";
import ancpIcon from "../assets/img/logo_ctag_white.png";

const publicSearchRoutes = ["grafico-evolucao-genetica", "avaliacao-genetica"];

export default function PublicAppContainer(props) {
  const location = useLocation();
  let isPublicSearchRoute = false;

  publicSearchRoutes.forEach((route) => {
    if (!isPublicSearchRoute)
      isPublicSearchRoute = location.pathname.includes(route);
  });

  location.isPublicSearchRoute = isPublicSearchRoute

  return (
    <>
      {isPublicSearchRoute ? (
        props.children
      ) : (
        <>
          <div className="row login-container">
            <div className="col-sm-6 ancp-background">
              <img src={ancpIcon} alt="CTAG NextGen" />
            </div>
            <div className="col-sm-6 centered-col">{props.children}</div>
          </div>
        </>
      )}
    </>
  );
}
